// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gbheqjbtmwplgpkcdsje.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdiaGVxamJ0bXdwbGdwa2Nkc2plIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE3MzU1NjQsImV4cCI6MjA2NzMxMTU2NH0.exARuEhp8h7-dd6UUTC4Q8UYYeOKx4iBvMD7JaWQB0E";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});